import type { FollowupFilters, FollowupView } from './types';

/**
 * The filter row as the query string GET /sentinel/followups accepts.
 *
 * One serialiser, as the action log has: the server answers any parameter outside its list
 * with a 400 rather than ignoring it, so everything that goes on the wire goes through here.
 * `bu_id` is not in this list on purpose: the service adds the brand scope, as every other
 * Sentinel read does.
 */
export const FOLLOWUP_QUERY_PARAMS = ['view', 'workflowId', 'reason', 'search', 'cursor', 'limit'] as const;

export type FollowupQuery = Partial<Record<(typeof FOLLOWUP_QUERY_PARAMS)[number], string>>;

export interface FollowupQueryInput {
  view: FollowupView;
  filters: FollowupFilters;
  limit?: number;
  cursor?: string | null;
}

export const toFollowupQueryParams = ({ view, filters, limit, cursor }: FollowupQueryInput): FollowupQuery => {
  const query: FollowupQuery = { view };
  if (filters.workflowId) query.workflowId = filters.workflowId;
  if (filters.reason) query.reason = filters.reason;
  const search = filters.search.trim();
  if (search) query.search = search;
  if (limit !== undefined) query.limit = String(limit);
  // Only a follow-up page has one; an empty cursor is a 400.
  if (cursor) query.cursor = cursor;
  return query;
};

/** The same query as a stable string, for cache keys. */
export const toFollowupSearchString = (input: FollowupQueryInput): string =>
  new URLSearchParams(toFollowupQueryParams(input)).toString();
